(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["big-editorial-hero"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('big-home-hero')){customElements.define('big-home-hero',class extends HTMLElement{
connectedCallback(){this.track=this.querySelector('.big-hero-track');this.slides=[...this.querySelectorAll('.big-hero-slide')];this.counter=this.querySelector('.big-hero-count');this.abort=new AbortController();const options={signal:this.abort.signal};this.paused=false;this.index=0;this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.move=(n)=>this.track.scrollTo({left:((n+this.slides.length)%this.slides.length)*this.track.clientWidth,behavior:this.reduce.matches?'instant':'smooth'});this.querySelector('[data-prev]')?.addEventListener('click',()=>{this.stop();this.move(this.index-1)},options);this.querySelector('[data-next]')?.addEventListener('click',()=>{this.stop();this.move(this.index+1)},options);this.querySelectorAll('[data-go]').forEach(b=>b.addEventListener('click',()=>{this.stop();this.move(Number(b.dataset.go))},options));this.track.addEventListener('scroll',()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.querySelectorAll('[data-go]').forEach((b,i)=>{if(i===this.index)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current')});if(this.counter)this.counter.textContent=String(this.index+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0')},options);this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.stop();this.move(this.index+(e.key==='ArrowRight'?1:-1))}},options);this.addEventListener('pointerdown',()=>this.stop(),options);this.querySelector('[data-pause]')?.addEventListener('click',()=>{this.paused=!this.paused;this.syncPause();if(this.paused)this.stop();else this.start()},options);this.addEventListener('mouseenter',()=>this.stop(),options);this.addEventListener('mouseleave',()=>this.start(),options);this.addEventListener('focusin',()=>this.stop(),options);this.addEventListener('focusout',()=>this.start(),options);document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.contains(e.target)||s===e.target);if(i>=0){this.stop();this.move(i)}},options);this.start()}
syncPause(){const b=this.querySelector('[data-pause]');if(b){b.textContent=this.paused?'▶':'Ⅱ';b.setAttribute('aria-label',this.paused?b.dataset.playLabel:b.dataset.pauseLabel)}}
start(){this.stop();if(this.dataset.rotate==='true'&&!this.paused&&!this.reduce.matches&&this.slides.length>1){this.timer=setInterval(()=>{if(!document.hidden&&!this.matches(':focus-within'))this.move(this.index+1)},Number(this.dataset.delay)*1000)}}
stop(){clearInterval(this.timer)}
disconnectedCallback(){this.stop();this.abort?.abort()}
})}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["big-product-edit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('big-product-carousel')){
  customElements.define('big-product-carousel',class extends HTMLElement{
    connectedCallback(){
      this.track=this.querySelector('.big-product-grid');
      this.cards=[...this.querySelectorAll('.big-product')];
      this.toolbar=this.querySelector('.big-edit-toolbar');
      this.prev=this.querySelector('[data-previous]');
      this.next=this.querySelector('[data-next]');
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.move=(direction,page=true)=>{
        if(!this.cards.length)return;
        const step=this.cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);
        const count=page?Math.max(1,Math.floor(this.track.clientWidth/step)):1;
        this.track.scrollBy({left:direction*count*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      this.prev.addEventListener('click',()=>this.move(-1),options);
      this.next.addEventListener('click',()=>this.move(1),options);
      this.track.addEventListener('keydown',e=>{
        if(e.target!==this.track)return;
        if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1,false)}
        if(e.key==='Home'||e.key==='End'){e.preventDefault();this.track.scrollTo({left:e.key==='Home'?0:this.track.scrollWidth,behavior:'instant'})}
      },options);
      this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update())},options);
      this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
    }
    update(){
      const max=this.track.scrollWidth-this.track.clientWidth;
      this.toolbar.hidden=max<=2;
      this.prev.disabled=this.track.scrollLeft<=2;
      this.next.disabled=this.track.scrollLeft>=max-2;
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame)}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["big-shop-room"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('big-shop-room')){
customElements.define('big-shop-room',class extends HTMLElement{
connectedCallback(){
this.abort=new AbortController();this.cards=[...this.querySelectorAll('[data-room-card]')];this.controls=[...this.querySelectorAll('[data-room-select]')];
this.select=(id)=>{this.cards.forEach(card=>card.hidden=card.dataset.roomCard!==id);this.controls.forEach(control=>{const active=control.dataset.roomSelect===id;if(control.tagName==='BUTTON')control.setAttribute('aria-pressed',String(active));else if(active)control.setAttribute('aria-current','true');else control.removeAttribute('aria-current')})};
this.controls.forEach(control=>control.addEventListener('click',e=>{e.preventDefault();this.select(control.dataset.roomSelect)},{signal:this.abort.signal}));
document.addEventListener('shopify:block:select',e=>{const card=this.cards.find(c=>c===e.target||c.contains(e.target));if(card)this.select(card.dataset.roomCard)},{signal:this.abort.signal});
if(this.cards[0])this.select(this.cards[0].dataset.roomCard);
}
disconnectedCallback(){this.abort?.abort()}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
